import type React from "react";
import ToolCard from "./ToolCard";

interface Tool {
	id: string;
	title: string;
	description: string;
	href: string;
	icon?: React.ElementType; // Add optional icon type
}

interface ToolGridProps {
	tools: Tool[];
}

export default function ToolGrid({ tools }: ToolGridProps) {
	return (
		<div className="grid grid-cols-2 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 md:gap-4">
			{tools.map((tool) => (
				<ToolCard
					description={tool.description}
					href={tool.href}
					icon={tool.icon}
					id={tool.id}
					key={tool.id}
					title={tool.title}
				/>
			))}
		</div>
	);
}
